/**
 * Copies all enumerable own properties from one or more source objects to a target object.
 * Alias for Object.assign providing a more functional API.
 *
 * @param target - The target object to copy to
 * @param sources - The source objects to copy from
 * @returns The modified target object
 *
 * @example
 * ```ts
 * import { RecordAssign } from "@pdfking/tfunc"
 *
 * RecordAssign({ a: 1 }, { b: 2 }, { c: 3 })
 * // { a: 1, b: 2, c: 3 }
 * ```
 */
export const RecordAssign = Object.assign
